export default{
    "store.index.598093-0": "Default",
    "store.index.598093-1": "Blue",
    "store.index.598093-2": "Data Mode",
    "store.index.598093-3": "Map Mode",
    "store.index.598093-4": "3D Mode"
}



// WEBPACK FOOTER //
// ./src/i18n/lang/En/store-en.js


// WEBPACK FOOTER //
// ./src/i18n/lang/En/store-en.js